import { html } from 'lit';

export const recordIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 24 24">
    <path
      fill="#EE333C"
      d="M22,14c-4.39,0-8,3.61-8,8s3.61,8,8,8s8-3.61,8-8C30.08,17.61,26.47,14,22,14L22,14z"
    />
    <path
      fill="var(--vst-color-fg-primary)"
      d="M21.97,12.07c5.5,0,9.97,4.47,9.97,9.97c0,5.5-4.47,9.97-9.97,9.97c-5.5,0-9.97-4.47-9.97-9.97C12,16.54,16.47,12.07,21.97,12.07 M21.97,10.07C15.36,10.07,10,15.42,10,22.03S15.36,34,21.97,34s11.97-5.36,11.97-11.97S28.58,10.07,21.97,10.07L21.97,10.07z"
    />
  </svg>
`;
